<script setup lang="ts">
const TooltipContents = defineAsyncComponent(
  () => import("@/components/TooltipContents.vue"),
);
defineProps<{
  text?: string;
  marginOffset?: number;
}>();
const enableDOM = ref(false);
const label = ref<HTMLSpanElement>();

function show() {
  enableDOM.value = true;
}
function hide() {
  enableDOM.value = false;
}
</script>

<template>
  <div>
    <span
      ref="label"
      tabindex="0"
      @focus="show"
      @blur="hide"
      @mouseenter="show"
      @mouseleave="hide"
    >
      <slot />
    </span>
    <TooltipContents
      v-if="enableDOM && label"
      :margin-offset="marginOffset"
      :label="label"
      ><slot name="content">{{ text }}</slot></TooltipContents
    >
  </div>
</template>

<style scoped lang="postcss"></style>
